(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanyCustomerSearch', CompanyCustomerSearch);

    CompanyCustomerSearch.$inject = ['$resource'];

    function CompanyCustomerSearch($resource) {
        var resourceUrl = 'api/_search/company-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
